module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/home-88007ad95e47a65ce35a25fe94403c0c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/home.svg
// module id = 9Z/h
// module chunks = 24